import { createPortalComponent, PortalName } from '../../../structural/createPortalComponent';

import './SheetPortalMountPoint.scss';

// this will assign the .SheetPortalMountPoint classname (derived from the enum value)
const { Portal, PortalMountPoint } = createPortalComponent(PortalName.Sheet);

export default Portal;
export const SheetPortalMountPoint = PortalMountPoint;
